export default {
  // Navigation
  'nav.spreadsheet': 'Tableur',
  'nav.categories': 'Catégories',
  'nav.guide': 'Guide',
  'nav.faq': 'FAQ',
  'nav.home': 'Accueil',
  'nav.shopping': 'Guide d’achat',
  'nav.cta': 'Acheter maintenant',

  // Hero
  'hero.badge': 'Ressource indépendante · Guides multilingues · Sécurité',
  'hero.h1': 'Tableur USFans — Trouvez, explorez et organisez les informations USFans',
  'hero.sub': 'Explorez les ressources du tableur USFans, les guides de créateurs, les avis, les informations d’expédition, les coupons, les guides d’entrepôt et les ressources de sécurité — le tout sur une plateforme rapide et facile à utiliser.',
  'hero.ctaPrimary': 'Explorer le tableur USFans',
  'hero.ctaSecondary': 'Lire le guide USFans',
  'hero.trust': 'Ressource indépendante • Contenu à jour • Guides multilingues • Sécurité',
  'hero.scroll': 'Faites défiler pour explorer',

  // Menu déroulant
  'dropdown.label': 'Parcourir les catégories',
  'dropdown.placeholder': 'Sélectionnez une catégorie…',

  // Catégories
  'categories.title': 'Acheter par catégorie',
  'categories.sub': 'Parcourez les catégories populaires USFans et découvrez des styles, le tout organisé au même endroit. Chaque lien ouvre la boutique officielle dans un nouvel onglet.',
  'categories.hint': 'Chaque catégorie mène à la boutique principale USFans.',
  'categories.view': 'Ouvrir la catégorie',

  // Cartes de fonctionnalités
  'features.title': 'Tout ce dont vous avez besoin au même endroit',
  'features.sub': 'Un centre de ressources USFans complet basé sur des informations claires et utiles.',
  'features.1.title': 'Tableur USFans',
  'features.1.desc': 'Explorez les ressources et guides organisés du tableur USFans.',
  'features.2.title': 'Avis USFans',
  'features.2.desc': 'Comprenez les fonctionnalités, l’ergonomie, l’expédition et les points importants.',
  'features.3.title': 'Coût d’expédition USFans',
  'features.3.desc': 'Apprenez comment fonctionnent les frais d’expédition et ce qui influence le prix final.',
  'features.4.title': 'Coupon USFans',
  'features.4.desc': 'Trouvez des informations sur les coupons, promotions et réductions.',
  'features.5.title': 'Entrepôt USFans',
  'features.5.desc': 'Apprenez comment fonctionnent le stockage, l’inspection et l’expédition.',
  'features.6.title': 'USFans est-il légitime ?',
  'features.6.desc': 'Comprenez la légitimité, la sécurité, la confidentialité et les risques courants.',

  // À propos
  'about.title': 'Vous cherchez une meilleure façon d’explorer les informations USFans ?',
  'about.p1': 'Notre centre du tableur USFans rassemble des guides utiles, des ressources de créateurs, des avis, des informations d’expédition, des explications sur l’entrepôt, des réductions, des comparaisons et des conseils de sécurité en une seule ressource.',
  'about.p2': 'Que vous découvriez USFans pour la première fois ou cherchiez une information précise, commencez par le centre du tableur USFans.',

  // Guide CTA
  'guide.title': 'Lisez notre guide du tableur USFans',
  'guide.sub': 'Un guide complet et original sur ce qu’est un tableur USFans, son fonctionnement, la recherche de créateurs et la sécurité.',
  'guide.cta': 'Lire le guide complet',
  'guide.meta': 'Mis à jour · Contenu original · Sécurité',

  // Guides
  'guides.title': 'Explorez tous les guides USFans',
  'guides.sub': 'Une bibliothèque complète de guides détaillés sur le tableur, les créateurs, les avis, l’expédition, les coupons, l’entrepôt et la sécurité.',

  // FAQ
  'faq.title': 'Questions fréquentes',
  'faq.sub': 'Des réponses rapides sur la ressource du tableur USFans.',
  'faq.1.q': 'Qu’est-ce qu’un tableur USFans ?',
  'faq.1.a': 'C’est une ressource organisée qui rassemble des informations USFans — listes de créateurs, catégories, guides et liens — en un seul endroit facile à parcourir.',
  'faq.2.q': 'Ce site est-il affilié à USFans ?',
  'faq.2.a': 'Non. USFansLink.rest est un site d’information indépendant, qui n’est pas nécessairement affilié à USFans, ni approuvé ou exploité par lui.',
  'faq.3.q': 'Comment parcourir les catégories USFans ?',
  'faq.3.a': 'Utilisez le menu déroulant ou les boutons de catégorie ci-dessous. Chacun ouvre la catégorie correspondante dans la boutique principale USFans.',
  'faq.4.q': 'Les guides sont-ils gratuits ?',
  'faq.4.a': 'Oui, tous les guides et articles de ce site sont gratuits et à but informatif.',
  'faq.5.q': 'Vérifiez-vous les informations ?',
  'faq.5.a': 'Nous cherchons à garder un contenu utile et précis, mais les informations de tiers peuvent changer. Vérifiez toujours les détails par vous-même.',

  // CTA principal
  'cta.title': 'Prêt à explorer la boutique USFans complète ?',
  'cta.sub': 'Parcourez la collection complète, découvrez de nouvelles catégories et achetez directement sur le site principal USFans.',
  'cta.primary': 'Tableur USFans',
  'cta.secondary': 'Acheter maintenant',

  // Pied de page
  'footer.tagline': 'Une ressource indépendante et multilingue pour explorer les informations USFans.',
  'footer.disclaimer': 'USFansLink.rest est un site d’information indépendant, qui n’est pas nécessairement affilié à USFans, ni approuvé ou exploité par lui. Les informations de tiers peuvent changer ; vérifiez les détails par vous-même.',
  'footer.links': 'Liens rapides',
  'footer.copyright': '© 2026 USFansLink.rest. Tous droits réservés.',

  // Article
  'article.breadcrumb': 'Accueil',
  'article.category': 'Guide',
  'article.shortTitle': 'Guide du tableur USFans',
  'article.readTime': '8 min de lecture',
  'article.updated': 'Mis à jour',
  'article.toc': 'Table des matières',
  'article.related': 'Guides associés',

  'article.h1': 'Tableur USFans : guide complet des créateurs, de la recherche et des ressources',
  'article.lead': 'Apprenez ce qu’est un tableur USFans, son fonctionnement, comment rechercher des créateurs, organiser les informations et rester en sécurité — dans un guide complet.',

  'article.s1.title': 'Qu’est-ce qu’un tableur USFans ?',
  'article.s1.p1': 'Un tableur USFans est une ressource organisée et partagée qui rassemble des informations liées à USFans dans un format structuré et facile à parcourir. Il réunit généralement des listes de créateurs, des catégories, des profils, des statuts, des dates de mise à jour et des liens utiles dans une vue similaire à un tableau.',
  'article.s1.p2': 'Pour beaucoup, le tableur sert de point de départ central. Au lieu de chercher dans de nombreuses pages séparées, les utilisateurs peuvent consulter une présentation organisée pour trouver rapidement ce qu’ils cherchent. C’est particulièrement utile pour découvrir de nouveaux créateurs et catégories.',

  'article.s2.title': 'Comment fonctionne le tableur',
  'article.s2.p1': 'La plupart des tableurs USFans suivent une structure simple basée sur des colonnes. Une mise en page typique comprend des colonnes pour le nom du créateur, la catégorie, le lien du profil, le statut actuel et la date de la dernière mise à jour. Cette structure facilite le tri, le filtrage et la comparaison des informations.',
  'article.s2.p2': 'Certains tableurs sont maintenus manuellement et mis à jour selon un calendrier, d’autres plus fréquemment. Comme les données peuvent changer, il est toujours judicieux de vérifier la source et les détails importants.',

  'article.s3.title': 'Comment rechercher des créateurs',
  'article.s3.p1': 'La recherche dans un tableur USFans commence souvent par les catégories ou les filtres. Si vous cherchez un créateur précis, utilisez la fonction de recherche ou de filtre pour affiner les résultats par nom. Si vous explorez, parcourez d’abord par catégorie.',
  'article.s3.p2': 'Une bonne approche consiste à commencer large puis à affiner. Commencez par une catégorie qui vous intéresse, puis regardez le statut et les informations de mise à jour pour privilégier les entrées actives.',

  'article.s4.title': 'Catégories courantes',
  'article.s4.p1': 'Les ressources USFans sont souvent regroupées en catégories pour faciliter la navigation. Elles incluent généralement des vêtements, des chaussures, des accessoires, des sacs, des ceintures, des parfums et d’autres articles. Le regroupement aide à comparer des options similaires côte à côte.',
  'article.s4.p2': 'Sur ce site, le menu déroulant et les boutons de catégorie mènent à la section correspondante de la boutique principale, pour passer directement de la recherche à la consultation de vrais produits.',

  'article.s5.title': 'Tableur vs répertoire vs recherche manuelle',
  'article.s5.p1': 'Il est utile de comprendre comment un tableur se compare à d’autres façons de trouver des informations. Le tableau ci-dessous résume les principales différences.',
  'article.table.c1': 'Aspect',
  'article.table.c2': 'Tableur',
  'article.table.c3': 'Répertoire',
  'article.table.c4': 'Recherche manuelle',
  'article.table.r1c1': 'Format',
  'article.table.r1c2': 'Lignes et colonnes structurées',
  'article.table.r1c3': 'Pages de listes par catégorie',
  'article.table.r1c4': 'Une recherche à la fois',
  'article.table.r2c1': 'Idéal pour',
  'article.table.r2c2': 'Parcourir et comparer',
  'article.table.r2c3': 'Naviguer par thème',
  'article.table.r2c4': 'Trouver un élément précis',
  'article.table.r3c1': 'Fraîcheur',
  'article.table.r3c2': 'Dépend des mises à jour',
  'article.table.r3c3': 'Dépend de la maintenance',
  'article.table.r3c4': 'Toujours en direct',
  'article.table.r4c1': 'Courbe d’apprentissage',
  'article.table.r4c2': 'Faible',
  'article.table.r4c3': 'Très faible',
  'article.table.r4c4': 'Aucune',

  'article.s6.title': 'Vérification des données et sécurité',
  'article.s6.p1': 'Comme les tableurs et répertoires USFans sont souvent maintenus par la communauté, les informations peuvent ne pas toujours être complètes ou à jour. Vérifiez toujours les détails importants, comme les liens, les prix et la disponibilité, directement sur la boutique officielle.',
  'article.s6.p2': 'Soyez prudent avec tout lien demandant des informations personnelles ou un paiement hors du site officiel. Utilisez des liens connus et fiables et ne partagez jamais vos mots de passe ni vos identifiants.',

  'article.s7.title': 'Considérations de confidentialité',
  'article.s7.p1': 'Lorsque vous parcourez des ressources tierces, soyez attentif aux informations que vous partagez. Évitez de saisir des données personnelles sensibles sur des pages inconnues et utilisez le site officiel pour tout compte ou achat.',
  'article.s7.p2': 'Cette ressource indépendante ne demande pas vos informations personnelles pour naviguer. Si une page demande des données inutiles, mieux vaut la fermer et revenir à la source officielle.',

  'article.conclusion.title': 'En résumé',
  'article.conclusion.p1': 'Un tableur USFans est un moyen pratique d’explorer créateurs, catégories et ressources au même endroit. Il fonctionne mieux associé à une vérification indépendante et à des habitudes de sécurité de bon sens.',
  'article.conclusion.p2': 'Prêt à parcourir de vrais produits ? Utilisez le menu des catégories sur la page d’accueil ou explorez directement la boutique USFans complète.',

  'article.cta': 'Explorer la ressource complète',
  'article.backHome': 'Retour à l’accueil',

  // Noms de catégories
  'cat.shoes': 'Chaussures',
  'cat.hoodies': 'Hoodies / Pulls',
  'cat.tshirts': 'T-shirts',
  'cat.jackets': 'Vestes',
  'cat.pants': 'Pantalons / Shorts',
  'cat.headwear': 'Couvre-chefs',
  'cat.sets': 'Ensembles',
  'cat.underwear': 'Sous-vêtements',
  'cat.jersey': 'Maillot',
  'cat.accessories': 'Accessoires',
  'cat.bags': 'Sacs',
  'cat.belts': 'Ceintures',
  'cat.perfumes': 'Parfums',
  'cat.other': 'Autres articles',
};